import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import AdminDashboardContent from './AdminDashboardContent';
import '../../../style/scss/dashboard-tv.scss';

// Reload the page periodically to also pick up new deploys
const PAGE_RELOAD_INTERVAL_MS = 30 * 60 * 1000;

const AdminDashboardTv: React.FC = () => {
    const location = useLocation();

    // Read the viewer token from the url, if one is present
    const viewerToken = new URLSearchParams(location.search).get('token') || undefined;

    // Reload the whole page on a fixed interval
    useEffect(() => {
        const timer = setInterval(() => {
            window.location.reload();
        }, PAGE_RELOAD_INTERVAL_MS);

        return () => clearInterval(timer);
    }, []);

    // Show the same layout as the normal admin dashboard, with
    // bigger text and without the interactive controls
    return (
        <div className='tv-dashboard'>
            <div className='container-wide'>
                <AdminDashboardContent tvMode viewerToken={viewerToken} />
            </div>
        </div>
    );
};

export default AdminDashboardTv;
